import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useSubmissionUtils from "pages/AppPages/Shared/Submissions/utils";
import SubmissionsTable from "pages/AppPages/Shared/Submissions/components/SubmissionsTable";
import SubmissionsTablePatientEmptyState from "pages/AppPages/Shared/Submissions/components/SubmissionsTablePatientEmptyState";
import usePatientSubmissionsDataColumns from "../../utils/usePatientSubmissionsDataColumns";
import { useFetchGroupUsers, useCurrentUser } from "utils/hooks";
import { AssignmentSubmission } from "types";

interface PatientsSubmissionsTableProps {
  groupId?: string;
  showGroupColumns?: boolean;
}

const PatientsSubmissionsTable = ({
  groupId,
  showGroupColumns = false,
}: PatientsSubmissionsTableProps) => {
  const submissionDataColumns =
    usePatientSubmissionsDataColumns(showGroupColumns);
  const { slug } = useParams();
  const { currentPatient, sortedSubmissions, showTableElements } =
    useSubmissionUtils(groupId);
  const { fetchGroupUsers } = useFetchGroupUsers();
  const { user } = useCurrentUser();

  useEffect(() => {
    if (groupId) {
      fetchGroupUsers(groupId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  const filterPatientGroupSubmissions = (submissions: AssignmentSubmission[]) =>
    submissions?.filter(
      (submission) =>
        submission.userId === user?.id &&
        submission.groupId === groupId &&
        !submission.hideFromPatient
    );

  const filterPatientSubmissions = (submissions: any[]) =>
    submissions?.filter((submission: any) => !submission.hideFromPatient);

  return (
    <>
      {showTableElements && (
        <SubmissionsTable
          data={
            groupId
              ? filterPatientGroupSubmissions(sortedSubmissions)
              : filterPatientSubmissions(sortedSubmissions)
          }
          submissionDataColumns={submissionDataColumns}
          slug={slug}
          currentPatient={currentPatient?.value}
          groupId={groupId}
        />
      )}
      {(sortedSubmissions?.length === 0 || !sortedSubmissions) && (
        <SubmissionsTablePatientEmptyState groupId={groupId} />
      )}
    </>
  );
};

export default PatientsSubmissionsTable;
